

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { BranchSetup } from "../../components/BranchSetup/BranchSetup";


export const BranchPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Branch"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Branch", navigateTo: "/branch" }
      ]}
      mainContents={<BranchSetup />}
    />
  );
};
